import { exchangeToken } from './mapped'
import { clearSavedGridFilters } from '../features/explore-grid/hooks/useDataGridFilter'
import {
  setAuthToken,
  setRefreshToken,
  setSessionAuthToken,
  setSessionRefreshToken,
} from './auth0'

export type SwitchOrgResult = { ok: true } | { ok: false; error?: string }

/**
 * Exchange the current session for one in `orgId` and store it — everything a
 * switch does except the reload, which the caller owns (the org picker reloads
 * in place; the URL guard strips `#fromLogin` first).
 *
 * The one switch path, shared by the org picker and `OrgPathGuard`, so a URL's
 * `/orgs/<id>` can never reach an org the picker could not: the exchange is the
 * authority on membership. `/api/exchangeToken` answers 200 with `{ error }`
 * when the reader is not allowed in, and a network failure rejects — both come
 * back here as `{ ok: false }`.
 */
export async function switchToOrg(
  authToken: string,
  orgId: string
): Promise<SwitchOrgResult> {
  try {
    const { access_token, refresh_token, error } = await exchangeToken(
      authToken,
      orgId
    )
    if (!access_token) return { ok: false, error }

    setAuthToken(access_token)
    setRefreshToken(refresh_token!)
    setSessionAuthToken(access_token)
    setSessionRefreshToken(refresh_token!)
    // The grid's per-browser-tab filters belong to the org being left.
    clearSavedGridFilters()
    return { ok: true }
  } catch {
    return { ok: false }
  }
}
